export default "__VITE_ASSET__DyHOUF0S__"